const Updates = () => (
  <>
    <path
      fill="currentColor"
      d="M12.137 20q2.88 0 5.056-1.768 2.175-1.77 2.746-4.532a.52.52 0 0 0-.044-.409.43.43 0 0 0-.333-.218.48.48 0 0 0-.375.092.66.66 0 0 0-.23.35 6.92 6.92 0 0 1-2.445 3.935Q14.607 19 12.137 19q-2.925 0-4.963-2.038Q5.137 14.926 5.137 12t2.037-4.962T12.137 5a6.65 6.65 0 0 1 2.917.656 7.8 7.8 0 0 1 2.41 1.806h-1.981a.48.48 0 0 0-.356.144.49.49 0 0 0-.144.356q0 .212.144.356a.49.49 0 0 0 .356.143h2.846q.343 0 .576-.232a.78.78 0 0 0 .232-.575V4.808a.48.48 0 0 0-.144-.356.49.49 0 0 0-.357-.144.48.48 0 0 0-.356.144.49.49 0 0 0-.143.356v1.888a8.3 8.3 0 0 0-2.718-1.984A7.8 7.8 0 0 0 12.137 4q-1.665 0-3.12.626a8.1 8.1 0 0 0-2.54 1.713 8.1 8.1 0 0 0-1.714 2.542 7.8 7.8 0 0 0-.626 3.118q0 1.665.626 3.12t1.713 2.541a8.1 8.1 0 0 0 2.542 1.714q1.454.626 3.119.626"
    />
    <path
      fill="currentColor"
      d="m14.812 14.085-2.293-2.293V8.5a.49.49 0 0 0-.143-.356A.48.48 0 0 0 12.02 8a.48.48 0 0 0-.357.144.48.48 0 0 0-.144.356v3.379q0 .152.056.297.056.143.187.274l2.342 2.343q.16.16.354.16.195 0 .354-.16a.47.47 0 0 0 .15-.364.5.5 0 0 0-.15-.344"
    />
  </>
)
export default Updates
